import { notification } from 'antd'

import * as StripeServices from '../../../middlewares/services/stripe.services'

export const GetSupportedPaymentCurrencies = async (account_id, setCurrencies) => {
    try {
        const {
            data: { supported_payment_currencies },
        } = await StripeServices.GetSupportedPaymentCurrencies(account_id)
        setCurrencies(supported_payment_currencies)
    } catch (error) {
        console.error('/GetSupportedPaymentCurrencies - error', error)
        notification.error({ message: 'Oops, an error occurred ! Code: 1' })
    }
}

export const handleCurrencyChange = (value, setSelectedCurrency, onChange) => {
    setSelectedCurrency(value)
    onChange(value)
}
